import { FC } from 'react'
import styles from './styles.module.scss'
import { Button } from '@/components/Button'

interface JoinMailingDecisionProps {
  onSubmit: (isJoiningMailingList: boolean) => void
}

export const JoinMailingDecision: FC<JoinMailingDecisionProps> = ({
  onSubmit,
}) => {
  return (
    <div className={styles.container}>
      <h3>
        Share your email and we’ll guide you through application next steps and
        Mettle features.
      </h3>
      <ul>
        <li>Get a confirmation email and application next steps</li>
        <li>Download the app and start applying</li>
        <li>Hear about new offers and features</li>
      </ul>
      <div className={styles.buttonContainer}>
        <Button className={styles.sendButton} onClick={() => onSubmit(true)}>
          Share my email
        </Button>
        <Button className={styles.sendButton} onClick={() => onSubmit(false)}>
          Skip to download app
        </Button>
      </div>
    </div>
  )
}
